export const CASE_STUDY_CLIENT_URL = "https://ozexteriors.com.au/";

export const CASE_STUDY_STAMP_LABEL = "CASE STUDY";

export const CASE_STUDY_STAMP_META = "POST-DEPLOYMENT";

export const CASE_STUDY_HEADLINE_ACCENT = "+6 Additional Appointments";

export const CASE_STUDY_HEADLINE_LINE2 = "Per Week";

export const CASE_STUDY_LEAD = {
  beforeLink: "After connecting a digital brain, ",
  afterLink:
    " started booking six more qualified appointments on the calendar every week.",
};

export const CASE_STUDY_SIDEBAR_META =
  "Real company · Australia · Weekly uplift after go-live";

export const CASE_STUDY_METRICS = [
  {
    value: "+6",
    label: "Additional appointments per week",
    sub: "Started after digital brain went live",
    highlight: true,
  },
  {
    value: "9 sec",
    label: "Average Response time",
    sub: "vs 30-40 min office",
    highlight: false,
  },
  {
    value: "100%",
    label: "After-hours capture",
    sub: "Outside business hours",
    highlight: false,
  },
];

export const CASE_STUDY_CLIENT = {
  name: "Oz Exteriors",
};

export const CASE_STUDY_INTRO = {
  beforeLink: "After deploying a digital brain, ",
  linkText: "Oz Exteriors",
  afterLink: " transformed their lead capture:",
};

export const CASE_STUDY_INTRO_BULLETS = [
  {
    lead: "+6 additional appointments/week:",
    detail: "qualified and booked automatically",
    accent: "orange",
  },
  {
    lead: "9-second response time:",
    detail: "24/7 instant engagement, including after hours",
    accent: "teal",
  },
];

export const CASE_STUDY_BEFORE_AFTER = {
  before: "Up to 11h overnight delay",
  after: "9 sec response time",
};

export const CASE_STUDY_OUTCOME =
  "Outcome: +6 additional appointments per week · after go-live";

export const CASE_STUDY_EVIDENCE_LABEL = "EVIDENCE · POST-DEPLOYMENT";

export const CASE_STUDY_EVIDENCE_IMAGE = "/images/cases/ozexteriors.png";

export const CASE_STUDY_EVIDENCE_CAPTION =
  "Calendar & qualification logs · Oz Exteriors deployment";
